import { render } from "./projectsSlider.vue?vue&type=template&id=3e5a1a2e&scoped=true"
import script from "./projectsSlider.vue?vue&type=script&lang=js"
export * from "./projectsSlider.vue?vue&type=script&lang=js"

import "./projectsSlider.vue?vue&type=style&index=0&id=3e5a1a2e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5a1a2e"]])

export default __exports__